<t4-container [title]="title" [isLoading]="isLoading">
  <canvas mdbChart
          [type]="type"
          [datasets]="datasets"
          [labels]="labels"
          [options]="chartOptions"></canvas>
</t4-container>
